/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://qqyxami5wnfffj5tqmjeasiqyq.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-osrpluktkjflfbu7b53qwet3ru",
    "aws_cognito_identity_pool_id": "eu-central-1:7fb67d4f-4626-4b9a-be3a-8a2a2fca4b0e",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_F2bu9SfVY",
    "aws_user_pools_web_client_id": "5bsf9ebpr5t80n3lhav4u4rtbr",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "hrameventsb7eca4d76cbc402aa3ec741cec5d1069103501-master",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
